export default __webpack_public_path__ + "static/media/system-volume-02.d21071e1.svg";